<template>
  <div class="row">
    <!--    central instance buttons v-if="commonModule.centralInstance"-->
    <div v-if="commonModule.centralInstance" class="action-button-layout">
      <div class="action-button">
        <button
            type="submit"
            id="refresh-order-details-btn"
            @click="openTaskForm()"
            class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
        >
          <i class="bx bx-plus-circle align-middle font-size-16"/>
          Dodaj strategię cenową
        </button>
      </div>
    </div>

    <div v-else class="action-button-layout">
      <div class="action-button" v-b-tooltip.hover
           title="Pobiera i aktualizuje wszystkie strategie cenowe z centralnego serwera">
        <button
            type="submit"
            id="update-tasks-from-central-btn"
            @click="updateTasksFromCentral()"
            class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
        >
          <i class="bx bx-plus-circle align-middle font-size-16"/>
          Pobierz strategie cenowe
        </button>
      </div>


      <div class="action-button" v-b-tooltip.hover title="Spośród aktywnych strategii cenowych wybiera te dla których dana apteka jest apteką wzorcową, pobiera lokalne
          ceny wg zasad zdefiniowanych w strategii np. z uwag na dokumentach zakupu, a następnie eksportuje ceny na
          serwer centralny.">
        <button
            type="submit"
            id="export-prices-to-central-btn"
            @click="exportPricesToCentral()"
            class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"

        >
          <i class="bx bx-plus-circle align-middle font-size-16"/>
          Eksportuj ceny do centrali
        </button>
      </div>


      <div class="action-button" v-b-tooltip.hover
           title="Implementuje zmiany cen w lokalnej aptece zgdonie z aktywnymi strategiami cenowymi.">
        <button
            type="submit"
            id="execute-all-tasks-btn"
            @click="openExecuteTasksProcessForm()"
            class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
        >
          <i class="bx bx-plus-circle align-middle font-size-16"/>
          Wymuś zmianę cen w aptece zgodnie ze strategiami
        </button>


      </div>


    </div>


    <b-modal
        v-model="executeAllTasksFormDisplayed"
        id="add-drugstore-form-modal"
        scrollable
        title="Czy na pewno uruchomić proces zmian cen?"
        title-class="font-18"
        hide-footer
        style="z-index:100000!important;"
        size="xl"
    >

      <div v-b-tooltip.hover
           title="Zaznacz tą opcję, aby wykonać jedynie symulację zmian. W takiej sytuacji, zostanie wygenerowany plik CSV z proponowanymi zmianami cen, ale nie zostaną one zaimplementowane w systemie Kamsoft.">
        <button
            type="submit"
            id="toggle-simulation-only-flag-tasks-btn"
            @click="toggleSimulationOnlyFlag()"
            class="d-none d-sm-inline-block btn btn-sm btn-light shadow-sm"
        >
          <input
              class="form-checkbox"
              id="checkbox-option-id-execute-tasks"
              ref="checkbox-option-id-execute-tasks"
              type="checkbox"
              name="Wykonaj tylko symulację"
              v-model="executeOnlySimulation"
          />
          Wykonaj tylko symulację
        </button>

      </div>
      <b-button variant="success" @click="executeAllTasks()">Wykonaj</b-button>
      <b-button variant="danger" @click="executeAllTasksFormDisplayed = false" style="margin-left: 4px;">Anuluj
      </b-button>

    </b-modal>


    <div class="row" v-if="dataFetched">
      <CommonTable2
          :table="tableData"
          @onItemAction="runTableAction($event)"
          @onSort="sort($event)"
          @onMassAction="runMassAction($event)"
          @onCheckItem="checkAction($event)"
          :sortColumn="sortingKey"
          :sortDirection="sortingDirection"
      />

    </div>

    <b-pagination
        v-model="currentPage"
        size="lg"
        :total-rows="pricesModule.getPricesTasksTotal"
        :per-page="50"
        aria-controls="prices-tasks-table"
    ></b-pagination>
    <b-modal
        v-model="showTaskForm"
        id="add-price-strategy-task-form-modal"
        scrollable
        title="Dodawanie/edycja strategii cenowej"
        title-class="font-18"
        hide-footer
        style="z-index:100000!important;"
        size="xl"
    >
      <div>

        <PricesTaskForm
            v-if="showTaskForm"
            :taskData="currentTaskData"
            @onTaskSaved="savePriceStrategyTask($event)"/>
      </div>
    </b-modal>


  </div>
</template>


<script>
import {priceStrategyTasksTableStructure} from "./data/priceStrategyTasksTableStructure";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import Swal from "sweetalert2";
import PricesTaskForm from "./PricesTaskForm.vue";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {log} from "@/state/pinia/log";
import {usePricesManagerModule} from "@/state/pinia/pricesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {priceSourceMap} from "@/views/PricesManager/data/priceStrategyTaskFormFields";

export default {
  name: "PricesTasksStage",
  components: {PricesTaskForm, CommonTable2},
  data() {
    return {
      priceTasks: [],
      showTaskForm: false,
      dataFetched: true,
      currentPage: 0,
      sortingDirection: "ASC",
      sortingKey: "name",
      tableHeaders: priceStrategyTasksTableStructure.headers,
      tableMassActions: priceStrategyTasksTableStructure.massActions,
      tableData: {},
      currentTaskData: null,
      executeOnlySimulation: false,
      executeAllTasksFormDisplayed: false,
    }
  },
  computed: {
    pricesModule(){
      return usePricesManagerModule();
    },

    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {

    openTaskForm() {
      this.showTaskForm = true;
    },
    savePriceStrategyTask(taskToSave) {
      // const exampleTask = {
      //   centralId: null,
      //    name: null,
      //    guid: null,
      //    description: null,
      //    beginDate: null,
      //    endDate: null,
      //    hasBeenImplemented: false,
      //    changeValue: null,
      //    increasePrice: true,
      //    percentChange : true,
      //    changeRetailPricesDirectly: false,
      //    applyForAllProducts :false,
      //    upperMarginLimit: null,
      //    bottomMarginLimit: null,
      //    defaultMargin: null,
      //    oneTimeRetailPricesChange: false,
      //   active: true,
      //   type: "PRICELIST",
      //   productListSource: {
      //      id: null,
      //      guid: null,
      //      type : 0,
      //      sourceCsvFilePath: null,
      //      sourceIdCnkn: null,
      //      sourceIdGrpn: null,
      //      sourceIdDokf: null,
      //      sourceIdDost: null,
      //      sourceDocumentNotes: null,
      //      numberOfDaysBackwardsToCheckDocumentNotes:0,
      //      filterRxProducts :false,
      //      filterOtcProducts: false,
      //      filterNfzProposalProducts:false,
      //      filterRecProducts:false,
      //      filterDatzkFrom: null,
      //      filterDatzkTo: null,
      //      sourceRegularUpdate : true,
      //      excludedSourceIdCnkn: null,
      //      excludedSourceIdGrpn: null,
      //      sourceDrugstoreClientId: 0,
      //      taskGuid: null,
      //      taskCentralId: null,
      //   },
      //   drugstoresClientIds:[],
      //    creationDate: null,
      //    lastUpdate: null,
      //    creator: null,
      //   lastUpdater: null,
      // }


      if (this.currentTaskData != null && this.currentTaskData.centralId != null) {
        var payload = {
          taskCentralId: this.currentTaskData.centralId,
          taskDto: taskToSave
        };
        this.pricesModule.httpUpdateTask(payload).then(() => {
          this.refreshPricesTasksList();
        });
        this.showTaskForm = false;
        this.currentTaskData = null;
      } else {
        log.log("Saving task:")
        log.log(taskToSave);
        this.pricesModule.httpAddTask({taskDto: taskToSave}).then(() => {
          this.refreshPricesTasksList();
        });
        this.showTaskForm = false;
        this.currentTaskData = null;
      }


    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    runTableAction(event) {
      log.log("Running action: " + event.action + " for item: " + event.itemData.centralId)
      log.log(event)
      if (event.action.action === "edit") {

        this.pricesModule.httpGetTaskByCentralId({centralId: event.itemData.centralId}).then((response) => {
          apiRequestsHelper.handleResponseWithDialogs(response, false);
          this.currentTaskData = JSON.parse(JSON.stringify(response.data.payload));

          for (const key of Object.keys(this.currentTaskData)) {
            if (key === "productListSource" && this.currentTaskData[key] != null) {
              for (const productSourceKey of Object.keys(this.currentTaskData[key])) {
                if (productSourceKey === "type") {
                  const reversedProductSourceMap = this.getReversedProductSourceTypesMap();
                  this.currentTaskData[key][productSourceKey] = reversedProductSourceMap[this.currentTaskData[key][productSourceKey]];
                }
              }
            }
          }
          log.log("Current task data:")
          log.log(this.currentTaskData)
          this.showTaskForm = true;

        })
            .catch((error) => {
              apiRequestsHelper.catchResponseError(error,"httpGetTaskByCentralId");
            });


      } else if (event.action.action === "delete") {
        this.showDeleteTaskConfirmation(event.itemData.centralId);
      }
    },

    getReversedProductSourceTypesMap() {
      var reversedPriceSourceMap = {};
      for (const key of Object.keys(priceSourceMap)) {
        reversedPriceSourceMap[priceSourceMap[key]] = key;
      }
      return reversedPriceSourceMap
    },
    showDeleteTaskConfirmation(taskCentralId) {
      Swal.fire({
        title: "Usunąć strategię?",
        text: "Czy na pewno usunąć strategię cenową o centralnym id: " + taskCentralId + "?. Operacja jest nieodwracalna!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak",
        dangerMode: true,
      }).then((result) => {
            if (result.value) {
              var payload = {
                centralId: taskCentralId
              };
              this.pricesModule.httpRemoveTask(payload).then(() => {
                this.refreshPricesTasksList();
              });
            } else {

              // Do nothing...
            }
          }
      )
      ;
    },
    sort(sortingKeyValue) {
      this.sortingKey = sortingKeyValue;
      this.toggleSortingDirection();
      this.refreshPricesTasksList();
    }
    ,
    runMassAction(action) {
      log.log("Mass action: " + action)
      // no mass actions
    }
    ,
    checkAction(event) {
      log.log("Check action: " + event)
      // no check actions
    }
    ,
    refreshPricesTasksList() {
      var payload = {
        page: this.currentPage,
        sortingDirection: this.sortingDirection,
        sortingKey: this.sortingKey
      };
      this.dataFetched = false;
      this.pricesModule.httpGetPricesTasksPaging(payload).then(() => {
        this.priceTasks = JSON.parse(JSON.stringify(this.pricesModule.getPricesTasks));
        this.tableData['data'] = this.priceTasks;
        this.dataFetched = true;
      });
    },
    executeAllTasks() {
      this.executeAllTasksFormDisplayed = false
      this.pricesModule.httpExecuteTaskInLocalDrugstoreProcedure({onlySimulation: this.executeOnlySimulation})
    },
    exportPricesToCentral() {
      this.pricesModule.httpExportPricesFromSourceDrugstoreToCentralProcedure()
    },
    updateTasksFromCentral() {
      this.pricesModule.httpUpdateTasksInLocalDrugstoreProcedure().then(()=>{
        this.refreshPricesTasksList();
      })
    },
    toggleSimulationOnlyFlag() {
      this.executeOnlySimulation = !this.executeOnlySimulation;
    },
    openExecuteTasksProcessForm() {
      this.executeAllTasksFormDisplayed = true;
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.refreshPricesTasksList();
      }
      ,
      deep: true,
    },

  }
  ,
  created() {
    this.tableData['headers'] = this.tableHeaders;
    this.tableData['massActions'] = this.tableMassActions;
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile().then(() => {
        this.refreshPricesTasksList();
      });
    });
  }
  ,

}
</script>

<style scoped>

.action-button-layout {
  clear: both;
  margin-bottom: 5px;
  display: block;
  padding-right: unset;
}

.action-button {
  float: right;
  margin-right: 2px;
  z-index: 0;
  padding-right: unset;
}

.slim-label {
  padding: unset !important;
}

.form-checkbox {
  margin: 5px;
}

</style>
